/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";

export default function Notificaciones(props) {
  const { mensaje, error, callback, temporal, cerrarMensaje } = props;

  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    setMostrar(true);

    if (temporal) {
      setTimeout(() => {
        setMostrar(false);
        setTimeout(() => {
          cerrarMensaje();
        }, 2000);
      }, 6000);
    }
  }, [props, error, callback, temporal, cerrarMensaje]);

  function cancelar() {
    setMostrar(false);
    setTimeout(() => {
      cerrarMensaje();
    }, 2000);
  }

  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        position: "fixed",
        top: mostrar ? "0px" : "-100px",
        opacity: mostrar ? 1 : 0,
        zIndex: 11,
        textAlign: "center",
        color: "white",
        transition: "top 1s, opacity 0.5s",
        transitionTimingFunction: "ease-out"
      }}
    >
      <div
        css={{
          position: "relative",
          padding: "17px 43px 18px 23px",
          width: "fit-content",
          backgroundColor: error ? "var(--rojoCertx)" : "var(--verdeCertx)",
          fontSize: "1.3em",
          boxShadow: "0px 0px 8px rgb(0 0 0 / 30%)"
        }}
      >
        <span>{mensaje}</span>
        {!callback && !temporal && (
          <i
            className="pi pi-times"
            css={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              fontSize: "1rem",
              color: "white"
            }}
            onClick={cancelar}
          />
        )}
      </div>
    </div>
  );
}
